import {Component, Input, Output, SimpleChanges, EventEmitter, ViewChild, ElementRef, forwardRef} from '@angular/core';
import {SistemaService} from '@servicios/Sistema.Service';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

declare var $: any;
declare function Focus(id : string) : any;

const noop = () =>
{
};

export const CUSTOM_Dropdown_CONTROL_VALUE_ACCESSOR: any =
{
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DropdownComponent),
  multi: true
};

@Component(
  {
    selector: 'dropdownCustom',
    templateUrl: './Dropdown.template.html',
    providers: [CUSTOM_Dropdown_CONTROL_VALUE_ACCESSOR]
  })

export class DropdownComponent implements ControlValueAccessor
{
  @ViewChild('ddMenu') ddMenu! : ElementRef;

  public innerValue : string = "";
  public datoSeleccionado : any;

  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  @Input() titulo : string = ""; // titulo del dd
  @Input() opciones : Array<any> = []; // lista de opciones
  @Input() valorName : string = ""; // nombre del atributo que se identificara como seleccionado, por ejemplo el id
  @Input() displayValor : string = ""; // nombre del que se desplegará
  @Input() displayValorIcon : string = ""; // icono que se desplegará junto al nombre
  @Input() displaybackgrountcolor : string = ""; // nombre del color de fondo
  @Input() buscar : boolean = true; // indica si se mostrará el campo de busqueda
  @Input() limpiarInput : boolean = true; // muestra o no el botón para limpiar la seleccion
  @Input() multiSelect : boolean = false; // indica si el select es multiple
  @Input() margenControl : boolean = true; // indica si el control lleva un margen de 30px (se recomienda para que el control sea responsivo automáticamente)

  @Input() clasesAdicionales : string = ""; // clases que se agregan al control

  @Input() errorActivo : boolean = false; // indica si el error esta habilitado para mostrarse
  @Input() verError : boolean = true; // indica si se muestra el error
  @Input() disabled : boolean = false; // indica si el control esta deshabilitado
  @Input() mensajeError : string = ""; // mensaje que desplegará cuando haya un error

  @Output() OpcionSeleccionada : EventEmitter<any> = new EventEmitter();
  @Output() OpcionLimpiada : EventEmitter<any> = new EventEmitter();

  public opcionesDisponibles : Array<any> = []; // lista de opciones visibles
  public busqueda : string = ""; // campo de busqueda

  public id : number = 0;

  constructor(public sistemaService : SistemaService)
  {
    this.sistemaService.numeroControl++;
    this.id = this.sistemaService.numeroControl;
  }

  ngOnChanges(changes: SimpleChanges)
  {
    if (changes.opciones?.currentValue)
    {
      this.SetDatoSelecciondo();
    }
  }

  SeleccionarOpcion(opcion : any)
  {
    if (this.multiSelect)
    {
      this.EvitarCierre();

      // set dato
      var seleccionado = [];

      if (this.sistemaService.TieneValor(this.valor))
      {
        seleccionado = this.valor.slice();
      }

      seleccionado.push(opcion[this.valorName]);
      this.valor = seleccionado;
    }
    else
    {
      this.valor = opcion[this.valorName];
    }

    this.OpcionSeleccionada.emit(opcion);
  }

  BorrarOpcion(opcion : any)
  {
    var seleccionado = [];

    if (this.valor)
    {
      seleccionado = this.valor.slice();
    }

    this.sistemaService.BorrarElementoValorPorValor(seleccionado, opcion[this.valorName]);
    this.valor = seleccionado;
  }

  SetDatoSelecciondo()
  {
    if (this.multiSelect)
    {
      this.datoSeleccionado = [];

      if (this.sistemaService.TieneValorArreglo(this.valor))
      {
        for (let i = 0; i < this.valor.length; i++)
        {
          for(let k = 0; k < this.opciones.length; k++)
          {
            if (this.opciones[k][this.valorName] === this.valor[i])
            {
              this.datoSeleccionado.push(this.opciones[k]);
              break;
            }
          }
        }
      }

      this.SetOpcionesDisponible();
    }
    else
    {
      this.datoSeleccionado = "";

      if (this.sistemaService.TieneValor(this.valor))
      {
        for(let k = 0; k < this.opciones.length; k++)
        {
          if (this.opciones[k][this.valorName] == this.valor)
          {
            this.datoSeleccionado = this.opciones[k];
            break;
          }
        }
      }
    }
  }

  SetOpcionesDisponible()
  {
    if (this.valor)
    {
      this.opcionesDisponibles = this.opciones.filter((opcion : any) =>
      {
        let elemento = opcion[this.valorName];
        let elemento2 = this.valor.find((p : any) => p === opcion[this.valorName]);

        return !this.sistemaService.TieneValor(this.valor.find((p : any) => p === opcion[this.valorName]));
      });
    }
    else
    {
      this.opcionesDisponibles = this.opciones;
    }
  }

  PermanecerAbiertoMenu()
  {
    if (this.multiSelect)
    {
      $("#ddDatosOpciones" + this.id).dropdown.open();
    }
  }

  LimpiarSelect()
  {
    this.valor = this.multiSelect ? [] : "";
    this.OpcionLimpiada.emit(null);
  }

  LimpiarBusqueda()
  {
    this.EvitarCierre();
    this.FocusBuscar();
  }

  FocusBuscar()
  {
    if (this.buscar)
    {
      this.busqueda = '';
      setTimeout(() =>
      {
        Focus('buscar' + this.id);
      }, 0);
    }
  }

  EvitarCierre()
  {
    $('#ddDatos' + this.id).click(function(e : any)
    {
      e.stopPropagation();
    });
  }

  // control ngModel
  get valor(): any
  {
    return this.innerValue;
  };

  //set accessor including call the onchange callback
  set valor(nuevoValor: any)
  {
    if (nuevoValor !== this.innerValue)
    {
      this.innerValue = nuevoValor;
      this.SetDatoSelecciondo();
      this.onChangeCallback(nuevoValor);
    }
  }

  writeValue(valor: any)
  {
    if (valor !== this.innerValue)
    {
      this.innerValue = valor;
      this.SetDatoSelecciondo();
    }
  }

  registerOnChange(fn: any)
  {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any)
  {
    this.onTouchedCallback = fn;
  }

  TeclaPresionada(tecla : any)
  {
    console.log(tecla);

    if(tecla.keyCode ==  13 || tecla.keyCode == 32)
    {
      $('#ddBoton' + this.id).click();
      this.FocusBuscar();
    }
  }
}
